import React, { useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label } from 'reactstrap';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { societyValidationSchema } from './utils/validations';
import { documentTypes } from '../../../../utility/helpers';

const SocietyFormModal = ({ isOpen, toggle, onSubmit, initialData }) => {
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(societyValidationSchema),
    defaultValues: {
      name: '',
      taxId: '',
      status: true,
    },
  });

  // Cargar datos iniciales para edición
  useEffect(() => {
    if (initialData) {
      reset(initialData);
    } else {
      reset({
        name: '',
        taxId: '',
        status: true,
      });
    }
  }, [initialData, reset]);

  const onSubmitForm = (data) => {
    onSubmit(data);
    toggle(); // Cerrar modal después de enviar
    reset(); // Limpiar formulario
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        {initialData ? 'Editar Sociedad' : 'Crear Nueva Sociedad'}
      </ModalHeader>
      <Form onSubmit={handleSubmit(onSubmitForm)}>
        <ModalBody>
          <FormGroup>
            <Label for="name">Nombre</Label>
            <Controller
              name="name"
              control={control}
              render={({ field }) => (
                <input
                  {...field}
                  id="name"
                  className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                  placeholder="Ingrese el nombre de la sociedad"
                />
              )}
            />
            {errors.name && <div className="invalid-feedback">{errors.name.message}</div>}
          </FormGroup>
          <FormGroup>
            <Label for="taxId">Tax ID</Label>
            <Controller
              name="taxId"
              control={control}
              render={({ field }) => (
                <input
                  {...field}
                  id="taxId"
                  className={`form-control ${errors.taxId ? 'is-invalid' : ''}`}
                  placeholder="Ingrese el Tax ID"
                />
              )}
            />
            {errors.taxId && <div className="invalid-feedback">{errors.taxId.message}</div>}
          </FormGroup>
          <FormGroup>
            <Label for="status">Estado</Label>
            <Controller
              name="status"
              control={control}
              render={({ field }) => (
                <select
                  {...field}
                  id="status"
                  className={`form-control ${errors.status ? 'is-invalid' : ''}`}
                >
                  <option value={true}>Activo</option>
                  <option value={false}>Inactivo</option>
                </select>
              )}
            />
            {errors.status && <div className="invalid-feedback">{errors.status.message}</div>}
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancelar
          </Button>
          <Button color="primary" type="submit">
            {initialData ? 'Guardar Cambios' : 'Crear'}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default SocietyFormModal;
